import { ICopyable, IOpChangeState, IOpObject, IReferenceType } from '../util/interfaces'

import { Enums } from '../common/enums'

import { CommonHelper } from '../../helpers/common-helper'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'

import { OpConsumerTypeData } from './op-consumer-type-data'
import { OpDataList } from '../util/op-data-list'
import { OpDataType } from './op-data-type'
import { OpDescr } from './op-descr'
import { OpDistributor } from './op-distributor'
import { Utils } from '../util/utils';



export class OpConsumerType implements IReferenceType, IOpObject, IOpChangeState, ICopyable<OpConsumerType> {

    // #region Properties

    public idConsumerType: number
    public idDistributor: number
    public idDescr: number
    public name: string

    // #endregion


    // #region Navigation Properties

    public descr: OpDescr
    public distributor: OpDistributor

    // #endregion


    // #region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpConsumerType) {
            this.copy(<OpConsumerType>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    // #endregion  Ctor End


    // #region IOpChangeState implementation

    public opState: Enums.OpChangeState

    // #endregion


    // #region IReferenceType implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdConsumerType
    }

    public getReferenceKey(): number {
        return this.idConsumerType
    }

    public getReferenceValue(): any {
        return this
    }

    // #endregion


    // #region IOpObject implementation

    public get idObject(): number {
        return this.idConsumerType
    }
    public set idObject(idObject: number) {
        this.idConsumerType = idObject
    }

    public dataList: OpDataList<OpConsumerTypeData> = new OpDataList<OpConsumerTypeData>()

    public dynamicValues: { Key: string, Value: any }[] = []

    public customFormatString: string;

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idConsumerType = opObj.ID_CONSUMER_TYPE
            this.idDescr = opObj.ID_DESCR
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.name = opObj.NAME

            this.dynamicValues = opObj.dynamicValues
            this.opState = opObj.OpState

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpConsumerTypeData(data)))
            }

            this.descr = opObj._Descr != null ? new OpDescr(opObj._Descr != null) : null
            this.distributor = opObj._Distributor != null ? new OpDistributor(opObj._Distributor != null) : null
        } else {
            this.idConsumerType = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_CONSUMER_TYPE: this.idConsumerType,
            ID_DISTRIBUTOR: this.idDistributor,
            ID_DESCR: this.idDescr,
            NAME: this.name,
            dynamicValues: this.dynamicValues,

            DataList: this.dataList ? this.dataList.ToJSON() : null,
            OpState: this.opState,
        }
    }

    public toString(): string {
        return this.name
    }

    // #endregion


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpConsumerType[]): JQueryPromise<OpConsumerType[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }


    // #region ICopyable

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpConsumerType {
        const consumerType: OpConsumerType = new OpConsumerType(null)

        consumerType.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return consumerType
    }

    public copy(source: OpConsumerType, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {

        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            this.descr = source.descr // TODO Zaimplementować ICopyable

            this.distributor = source.distributor != null ? source.distributor.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues) : null
        }

        if (includeCustomProperties) {
            // No Custom Properties
        }

        if (includeDataList) {
            if (source.dataList != null) {
                source.dataList.toArray().forEach((data: OpConsumerTypeData) => {
                    this.dataList.push(data.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues))
                })
            }
        }

        if (includeDynamicValues) {
            this.dynamicValues = source.dynamicValues
        }

        this.idConsumerType = source.idConsumerType
        this.idDistributor = source.idDistributor
        this.idDescr = source.idDescr
        this.name = source.name

        this.opState = source.opState
    }

    // #endregion 
}